import { Middleware } from "redux"
import { AppDispatch, AppRootState, AppThunk } from "./appStore"
import { serializeFusionError } from "@fusion-advantage/backcompat"
import { appError } from "./errorSlice"
import { selectStateFlatAllSettings, SettingPersistRow, settingStateToUpdatePersistRows } from "../lib/setting"
import { updateStoredSettings } from "../dal2/storedSetting"

export const storeSettingsMw: Middleware<{}, AppRootState> = store => {
	const dispatch = store.dispatch as AppDispatch
	return next => action => {
		const prevState = store.getState()
		const result = next(action)
		const nextState = store.getState()
		// after initial restore,
		// updates to settings should be persisted
		const prevSettings = selectStateFlatAllSettings(prevState)
		const nextSettings = selectStateFlatAllSettings(nextState)
		if(
			nextState.app.booted &&
			prevSettings !== nextSettings
		) {
			const updates = settingStateToUpdatePersistRows(prevSettings, nextSettings)
			if(updates.length > 0) {
				dispatch(updateStoredSettingsThunk(updates))
			}
		}
		return result
	}
}

const updateStoredSettingsThunk = (rows: SettingPersistRow[]): AppThunk<Promise<void>> => async (dispatch) => {
	const r = await updateStoredSettings(rows)
	if(r.isErr()) {
		dispatch(appError({
			err: serializeFusionError('storedSettingsMw', r.error)
		}))
	}
}
